// @flow
import React, { memo, type Element } from 'react';
import PartnerEdit from './PartnerEdit';

const PartnerList = (): Element<*> => <PartnerEdit />;

export default memo<*>(PartnerList);
